export const convertMoneyToPoints = ({ money, decode }) => {
  const PERCENTAGE_BASE = 100;
  if (money === null) return;
  return money * (decode / PERCENTAGE_BASE);
};
